import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-6" }

import { onMounted, ref } from "vue";
import TopicService from "../services/TopicService";
import CreateBatch from "../components/sendEmailBatch/CreateBatch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendEmailBatch',
  setup(__props) {

const data = ref<any>({});
const isLoading = ref(false);
const createBatchRef = ref<any>(null);
const receiverEmails = ref(
  "dealing@bacera.com,kay.wu@bacera.com,jiehe@bacera.com"
);

const sendEmail = async () => {
  isLoading.value = true;
  try {
    await TopicService.sendEmailBatch({
      uuid: data.value.uuid,
      total: data.value.total,
    });
    await fetchData();
    console.log("clicked");
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const sendTestEmail = async () => {
  isLoading.value = true;
  try {
    var unTrimmedEmailList = receiverEmails.value.split(",");
    var trimmedEmailList = unTrimmedEmailList
      .map((email) => email.trim())
      .filter((email) => email !== "");
    await TopicService.sendtestEmailBatch({
      testEmails: trimmedEmailList,
      uuid: data.value.uuid,
    });
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    data.value = await TopicService.getEmailBatchList();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (createBatchRef.value.show())),
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create Batch")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: fetchData,
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("Refresh")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            (data.value.contents)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Title: " + _toDisplayString(data.value?.contents["en-us"]?.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, "Topic Key: " + _toDisplayString(data.value.topicKey), 1),
            _createElementVNode("div", null, "uuid: " + _toDisplayString(data.value.uuid), 1),
            _createElementVNode("div", null, "Total Emails: " + _toDisplayString(data.value.total), 1),
            _createElementVNode("div", null, "Status: " + _toDisplayString(data.value.status), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, "Sent: " + _toDisplayString(data.value.sent), 1),
              _createElementVNode("div", null, "Failed: " + _toDisplayString(data.value.failed), 1),
              _createElementVNode("div", null, "Failed Email : " + _toDisplayString(data.value.failedEmails), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (createBatchRef.value.show(data.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Edit")
              ]),
              _: 1
            }),
            _createVNode(_component_el_popconfirm, {
              class: "box-item",
              title: "Confirm to send emails?",
              placement: "top-start",
              onConfirm: sendEmail
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sent Emails")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_input, {
            disabled: isLoading.value,
            class: "w-500px me-6",
            modelValue: receiverEmails.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((receiverEmails).value = $event)),
            autosize: { minRows: 2, maxRows: 4 },
            type: "textarea",
            placeholder: "Enter email addresses separated by comma"
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: sendTestEmail,
            loading: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("Send Test Email")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createVNode(CreateBatch, {
      ref_key: "createBatchRef",
      ref: createBatchRef,
      onEventSubmit: fetchData
    }, null, 512)
  ], 64))
}
}

})